import React from 'react'
import Script from 'next/script'

type InitScriptsProps = {
    scripts: string[]
}

export const InitScripts = ({
    scripts = []
}: InitScriptsProps): JSX.Element => {
    const activeScripts = scripts.filter((script) => Boolean(script?.trim()))

    return (
        <>
            {activeScripts.map((script: string, idx: number) => (
                <Script
                    key={idx}
                    id={`tag-manager-script-${idx}`}
                    dangerouslySetInnerHTML={{ __html: script }}
                />
            ))}
        </>
    )
}
